<template>
  <v-container>
    <h2 style="color:gray">Cài đặt phản hồi</h2>
    <v-divider class="my-3"></v-divider>
    <v-row class="py-3">
      <v-col cols="12">
        <v-checkbox
          hide-details
          value="view-feedback-group"
          :label="'Cho phép ' + roleName + ' phản hồi phụ huynh'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>
